import { Loader } from "semantic-ui-react";

export default function Loading() {
  return <Loader active inline />;
}
